export default __webpack_public_path__ + "static/spiral-738a8715ecf5980aa35dd65d16aa47c1.svg";